<template>
    <section class="p-0" id="clients">
      <div id="clients-header" class="masthead text-white text-center">
        <div class="container h-100 d-flex justify-content-center">
          <div class="my-auto">
            <hr class="light" data-aos="fade-right">
            <h1 class="text-white">
              CLIENTES <br>
              una historia de éxito
            </h1>
            <hr class="light" data-aos="fade-left">
          </div>
       </div>
      </div>
      <div class="container-fluid p-0">
          <div class="row no-gutters">
              <div class="col-md-12 text-center text-white p-4 reddet">
                  <h3 class="text-white m-0">ALGUNAS DE LAS MARCAS QUE HAN CONFIADO EN NOSOTROS</h3>
              </div>
          </div>
      </div>
      <div id="clients-content" class="text-white text-center">
        <div class="container">
            <div class="row text-center">
                <div class="col-xl-12">
                  <div class="row d-none d-lg-block">
                        <div class="col-lg-12 col-sm-12"><img class="img-fluid" src="/../img/Clientes_todo.png"></div>
                  </div>
                  <div class="row d-lg-none">
                        <div class="col-md-3 col-sm-12"><img class="img-fluid" src="/../img/clients/clientes_06.png"></div>
                        <div class="col-md-3 col-sm-12"><img class="img-fluid" src="/../img/clients/clientes_08.png"></div>
                        <div class="col-md-3 col-sm-12"><img class="img-fluid" src="/../img/clients/clientes_10.png"></div>
                        <div class="col-md-3 col-sm-12"><img class="img-fluid" src="/../img/clients/clientes_12.png"></div>
                        <div class="col-md-3 col-sm-12"><img class="img-fluid" src="/../img/clients/clientes_14.png"></div>
                        <div class="col-md-3 col-sm-12"><img class="img-fluid" src="/../img/clients/clientes_21.png"></div>
                        <div class="col-md-3 col-sm-12"><img class="img-fluid" src="/../img/clients/clientes_22.png"></div>
                        <div class="col-md-3 col-sm-12"><img class="img-fluid" src="/../img/clients/clientes_23.png"></div>
                        <div class="col-md-3 col-sm-12"><img class="img-fluid" src="/../img/clients/clientes_24.png"></div>
                        <div class="col-md-3 col-sm-12"><img class="img-fluid" src="/../img/clients/clientes_25.png"></div>
                        <div class="col-md-3 col-sm-12"><img class="img-fluid" src="/../img/clients/clientes_31.png"></div>
                        <div class="col-md-3 col-sm-12"><img class="img-fluid" src="/../img/clients/clientes_32.png"></div>
                        <div class="col-md-3 col-sm-12"><img class="img-fluid" src="/../img/clients/clientes_33.png"></div>
                        <div class="col-md-3 col-sm-12"><img class="img-fluid" src="/../img/clients/clientes_34.png"></div>
                        <div class="col-md-3 col-sm-12"><img class="img-fluid" src="/../img/clients/clientes_35.png"></div>
                        <div class="col-md-3 col-sm-12"><img class="img-fluid" src="/../img/clients/clientes_41.png"></div>
                        <div class="col-md-3 col-sm-12"><img class="img-fluid" src="/../img/clients/clientes_42.png"></div>
                        <div class="col-md-3 col-sm-12"><img class="img-fluid" src="/../img/clients/clientes_43.png"></div>
                        <div class="col-md-3 col-sm-12"><img class="img-fluid" src="/../img/clients/clientes_44.png"></div>
                        <div class="col-md-3 col-sm-12"><img class="img-fluid" src="/../img/clients/clientes_46.png"></div>
                        <div class="col-md-6 col-sm-12"><img class="img-fluid" src="/../img/clients/clientes_52.png"></div>
                        <div class="col-md-6 col-sm-12"><img class="img-fluid" src="/../img/clients/clientes_53.png"></div>
                    </div>
                </div>
            </div>
        </div>
      </div>
    </section>
</template>
<script>
export default {
    name: 'Coverage',
    components: {
    }
}
</script>
<style scoped lang="scss">
    @import "./Styles.scss"
</style>


// WEBPACK FOOTER //
// resources/assets/vue/components/clients/Clients.vue